
export enum MessageCategoryEnum {
    TRANSACTIONAL = 'TRN',
    KPI_TRACKER = 'KPI',
    PROGRESS_TRACKER = 'PRGT',
    PROMOTIONAL = 'PRML'
}
// Please change the below display values object as the values in MessageCategoryEnum are changed
export const MessageCategoryDisplayValues = {
    TRN : 'Transactional',
    KPI : 'KPI Tracker',
    PRGT : 'Progress Tracker',
    PRML : 'Promotional'
}